import { render, staticRenderFns } from "./leaderboard-clicks-card.vue?vue&type=template&id=7ef85738&scoped=true&"
import script from "./leaderboard-clicks-card.vue?vue&type=script&lang=js&"
export * from "./leaderboard-clicks-card.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-clicks-card.vue?vue&type=style&index=0&id=7ef85738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef85738",
  null
  
)

export default component.exports